import ReminderActionModel from '@/common/models/rules/actions/reminder-action-model';
import EntityModel from '@/common/models/entity-model';
import ScheduleInstructionModel from '@/common/models/rules/schedule-instruction-model';
import {DateTimeFormats} from '@/common/datetime-formats';
import _ from '@/common/helpers';

export class ScheduleModel extends EntityModel {
    hydrate({
        chronology = ScheduleModel.Chronologies.before,
        instructions = [],
    } = {}) {
        this.chronology = chronology;
        this.instructions = instructions
            .map(instruction => new ScheduleInstructionModel(instruction));
    }

    getPayload() {
        return {
            chronology: this.chronology,
            instructions: this.instructions.map(instruction => instruction.getPayload()),
        };
    }

    static Chronologies = {
        before: 'before',
        after: 'after',
    };
}

export default class ScheduleReminderActionModel extends ReminderActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {schedule = {}} = fields;
        this.schedule = new ScheduleModel(schedule);
    }

    getPayload() {
        return {
            schedule: this.schedule.getPayload(),
            ...super.getPayload(),
        };
    }

    getSummary(relatedEventName) {
        const getTime = (instruction) => {
            if (instruction.time) {
                return instruction.time.format(DateTimeFormats.timelineTime);
            }
            return `the same time`;
        };

        const lines = [];
        this.schedule.instructions.forEach((instruction, index) => {
            let line = null;
            switch (instruction.method) {
                case ScheduleInstructionModel.Methods.dateInterval:
                    line = `${instruction.duration} ${instruction.unitLabel}`;
                    break;
                case ScheduleInstructionModel.Methods.intelligent:
                    line = `intelligently within ${instruction.duration} ${instruction.unitLabel}`;
                    break;
                case ScheduleInstructionModel.Methods.dayOfMonth:
                    line = `on the ${_.ordinal(instruction.day)} day of the month at ${getTime(instruction)}`;
                    break;
                case ScheduleInstructionModel.Methods.dayOfWeek:
                    line = `on the ${instruction.weekLabel} ${instruction.day} at ${getTime(instruction)}`;
                    break;
                default:
                    return;
            }
            if (index === 0) {
                line += ` ${this.schedule.chronology} ${relatedEventName.toLowerCase()}`;
            } else {
                line += ` after attempt #${index}`;
            }
            lines.push(line);
        });

        return lines;
    }
}
